import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class Carousel extends Component{

    state = {
       slideNumber : 0,
       slidesVisibleNumber : 5, 
       containerWidth : 0,
       slideListLeftPos : 0,
       previousSlideListLeftPos : 0,
       currentSlide : 0,
       nextSlide : 0,
       swipeOffset : 0,
       isAnimating : false,
       refs : [],
       triggerZone : this.props.slideWidth / 9
   
    }
    componentWillMount(){
        if(typeof this.props.selectedAvatarNumber !== 'undefined' && this.props.selectedAvatarNumber > 0 ){
            this.setState({ currentSlide: parseInt(this.props.selectedAvatarNumber,10) });

        }else{
            // if component has no selectedAvatar Props set by default, we force to display the avatar (which is the one of the middle)
            let slideNum = React.Children.count(this.props.children);
            if(Object.values(this.props.children).length === 2){
                // if there is an input associated, we make sure to count only the img child elements
                slideNum = (Object.values(this.props.children)[0].length)-1;
            }
            
            this.setState({ currentSlide: Math.floor(slideNum/2) });
        }
    }

    componentDidMount() {    
        this.setInitialDimensions();
        this.touchObject = {};
        
        this.goToSlide(this.state.currentSlide); 
    }

    componentWillUpdate(nextProps) {

        if ( nextProps.selectedAvatarNumber !== this.props.selectedAvatarNumber && typeof this.props.selectedAvatarNumber !== 'undefined' && this.props.selectedAvatarNumber > 0 ) {
            this.setState({ currentSlide: parseInt(nextProps.selectedAvatarNumber,10) });
            this.goToSlide( parseInt(nextProps.selectedAvatarNumber, 10));
        }
    
    }

    setInitialDimensions(){
        
        let slideNum = React.Children.count(this.props.children);
        if(Object.values(this.props.children).length === 2){
            // if there is an input associated, we make sure to count only the img child elements
            slideNum = Object.values(this.props.children)[0].length;
        }

        let containerWidth = 0;
        for (let i = 0; i < slideNum; i++) {
           let element = 'slide'+i;
           if(i < this.state.slidesVisibleNumber){
               containerWidth += parseInt(ReactDOM.findDOMNode(this.refs[element]).offsetWidth, 10); 
           }
        }

        this.setState({ slideNumber: slideNum,
            containerWidth : containerWidth, 
        });
    }

    swipeDirection(x1, x2, y1, y2) {
        const xDist = x1 - x2;
        const yDist = y1 - y2;
        const r = Math.atan2(yDist, xDist);
        let swipeAngle = Math.round(r * 180 / Math.PI);
    
        if (swipeAngle < 0) {
          swipeAngle = 360 - Math.abs(swipeAngle);
        }
      
        if (swipeAngle <= 45 && swipeAngle >= 0) { 
          return -1;
        }
        if (swipeAngle <= 360 && swipeAngle >= 315) {
          return -1;
        }
        if (swipeAngle >= 135 && swipeAngle <= 225) {
          return 1;
        }
        
    }

    handleSwipe() {
            
        if (Math.abs(this.touchObject.length) > this.state.triggerZone) {

            if (this.touchObject.direction === -1) {
                if ( this.state.currentSlide < React.Children.count(this.props.children[0]) - 1 ) {

                    const nextSlide = parseInt(this.state.currentSlide, 10) + 1;
                    this.goToSlide(nextSlide);

                } else {
                    //console.log('limit right');
                }
            } else if (this.touchObject.direction === 1) {
                if (this.state.currentSlide > 0) {
                
                    const prevSlide = parseInt(this.state.currentSlide, 10)- 1;
                    this.goToSlide(prevSlide);
              
                }else{
                    //console.log('limit left');
                }
            }
        }
      
        this.touchObject = {};
    }

    handlerNextSlide = () => {
      if (this.state.currentSlide < this.state.slideNumber - 1 ) {
        const nextSlide = parseInt(this.state.currentSlide, 10) + 1;
        this.goToSlide(nextSlide);
      }
    }

    handlerPreviousSlide = () => {
      if (this.state.currentSlide > 0 ) {
        const nextSlide = parseInt(this.state.currentSlide, 10) - 1;
        this.goToSlide(nextSlide);
      }
    }

    goToSlide(targetIndex){
        
        let newPosLeft =  - (this.props.slideWidth * (targetIndex-(Math.floor(this.state.slidesVisibleNumber/2))));
        let prevPosLeft = 0
        
        if(this.state.swipeOffset < 0){
            prevPosLeft = this.state.slideListLeftPos + this.state.swipeOffset; 
        }else{
            prevPosLeft = parseInt(this.state.slideListLeftPos, 10) + parseInt(this.props.slideWidth, 10) + parseInt(this.state.swipeOffset, 10);
        }

        // EBE, here an event is manually trigger so as to have the input's value reflected into the form validation,
        // just forcing the refresh the input with state in the render() is not enough, triggering onChange value helps to refresh the states for the form
        const fakeEventDom = { target : { value : targetIndex } };
        this.props.onChange(fakeEventDom, 'avatar');

        this.setState({
            slideListLeftPos: newPosLeft,
            previousSlideListLeftPos :prevPosLeft, 
            currentSlide:targetIndex,
            //isAnimating : true
        });

        /*
        setTimeout(() => {
            this.setState({
                isAnimating : false
            });
        }, 400);
        */
        
    }


    bindTouchEvents() {
    
        return {
            // similar as : onTouchStart={touchStartEvent => this.handleTouchStart(touchStartEvent)}  
            onTouchStart: e => {
                this.touchObject = {
                   startX: e.touches[0].pageX,
                   startY: e.touches[0].pageY
                };
                
            },
            onTouchMove: e => {
                const direction = this.swipeDirection(
                    this.touchObject.startX,
                    e.touches[0].pageX,
                    this.touchObject.startY,
                    e.touches[0].pageY
                );
        
                if (direction !== 0) {
                  e.preventDefault();
                }
    
                // compute mouse deplacement
                let length = Math.abs(e.touches[0].pageX - this.touchObject.startX);

                this.touchObject = {
                    startX: this.touchObject.startX,
                    startY: this.touchObject.startY,
                    endX: e.touches[0].pageX,
                    endY: e.touches[0].pageY,
                    length,
                    direction
                };
                
                // get the swipe offet (based on the direction)
                //let swipeOffset = this.touchObject.length * this.touchObject.direction;
                          
                /*
                this.setState({
                    //slideListLeftPos :  this.state.previousSlideListLeftPos + swipeOffset,
                    swipeOffset : swipeOffset,
                });*/
                
            },
            onTouchEnd: e => {
                this.handleSwipe(e);
                
            },
            onTouchCancel: e => {
                this.handleSwipe(e);
                
            }
        }
    }

    bindMouseEvents() {
     
        return {
          onMouseDown: e => {
            this.touchObject = {
              startX: e.clientX,
              startY: e.clientY
            };
    
          },
          onMouseMove: e => {
    
            const direction = this.swipeDirection(
              this.touchObject.startX,
              e.clientX,
              this.touchObject.startY,
              e.clientY
            );
    
            if (direction !== 0) {
              e.preventDefault();
            }
    
            let length = Math.abs(e.clientX - this.touchObject.startX);
    
            this.touchObject = {
              startX: this.touchObject.startX,
              startY: this.touchObject.startY,
              endX: e.clientX,
              endY: e.clientY,
              length,
              direction
            };
    
            
          },
          onMouseUp: e => {
            this.handleSwipe(e);
          },
          onMouseLeave: e => {
            this.handleSwipe(e);
          }
        };
    }

    bindClickEvents(){
        return {
            onClick: e => {
                if(e.target.parentNode.classList.contains('selected')){
                    e.preventDefault();
                }else{
                    
                    let targetSlideIndex = 0;
                    if((typeof e.target.parentNode!=='undefined') && (e.target.parentNode.getAttribute('data-index'))){
  
                        targetSlideIndex = parseInt(e.target.parentNode.getAttribute('data-index'), 10);
                        if ( this.state.currentSlide <= React.Children.count(this.props.children) && this.state.currentSlide >= 0) {
                            this.goToSlide(targetSlideIndex);
                        }
                    }
                }
            }
        }
    }

    render(){

        const containerStyle = {
            width:this.state.slidesVisibleNumber * this.props.slideWidth,
            height:parseInt(this.props.slideHeight, 10)
        }

        const listStyle = {
            width: this.props.slideWidth*this.state.slideNumber,
            marginLeft: - (this.props.slideWidth * (this.state.currentSlide-(Math.floor(this.state.slidesVisibleNumber/2)))),
        }

        return [
            <div className="carousel-container" key="carousel-container-000001" style={containerStyle} >
                <ul className="slide-list" ref="list" style={listStyle} >
                    { 
                      
                      React.Children.map(this.props.children, (child, index) => {
                          
                        if(child.type==='img'){
                            const slideStyle = {width: parseInt(this.props.slideWidth, 10),
                                                height: parseInt(this.props.slideHeight, 10) 
                                            }
                            const touchEvents = this.bindTouchEvents();
                            const mouseEvents = this.bindMouseEvents();
                            const clickEvents = this.bindClickEvents();

                            const slideClasses = ['slide'];
                            
                            if ( this.state.currentSlide === index ) {
                                slideClasses.push('selected');
                            }
                                                
                            return (
                                    <li className={slideClasses.join(' ')} data-index={index} style={slideStyle} ref={`slide${index}`} {...touchEvents} {...mouseEvents} {...clickEvents} >
                                        { React.cloneElement(child, {ref:'img'+index} )} 
                                    </li>
                                ); 
                        }else if(child.type==='input'){
                            return React.cloneElement(child, {value:this.state.currentSlide})
                            
                        }          
                      })
                    }
                    
                 </ul>

            </div>,
            <div key="carousel-container-previous-000001"  className="previous" onClick={this.handlerPreviousSlide} />,
            <div key="carousel-container-next-000001"  className="next" onClick={this.handlerNextSlide} />
        ];
    }

}

export default Carousel;


// WEBPACK FOOTER //
// ./src/components/Carousel/Carousel.js